import { HttpStatusCode } from 'src/data/protocols/http/http-client'
import { AccessDeniedError } from 'src/domain/errors/access-denied-error'
import { NotFoundError } from 'src/domain/errors/not-found-error'
import { UnauthorizedError } from 'src/domain/errors/unauthorized-error'
import { UnexpectedError } from 'src/domain/errors/unexpected-error'

export class RemoteApiOpen {
  url: string

  httpClient: any

  constructor(url: string, httpClient: any) {
    this.url = url
    this.httpClient = httpClient
  }

  async index(params: any, headers?: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params,
      headers,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.badRequest: throw new Error('Erro na requisição.')
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.created: return httpResponse.body
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async create(params?: any, data?: any, headers?: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      params,
      data,
      headers,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.badRequest: throw new Error('Erro na requisição.')
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.created: return httpResponse.body
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async update(params: any, data: any, headers?: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      params,
      data,
      headers,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.badRequest: throw new Error('Erro na requisição.')
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.created: return httpResponse.body
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async delete(params: any, headers?: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'delete',
      params,
      headers,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.notFound: throw new NotFoundError()
      case HttpStatusCode.badRequest: throw new Error('Erro na requisição.')
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.created: return httpResponse.body
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }
}
